import React from 'react';
import Head from 'next/head';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import get from 'lodash.get';

import { globalLoadComplete } from 'redux/modules/router';
import { setVertical, setPageView } from 'redux/modules/shared';

import { layout as servicesLayoutPropType } from 'lib/CustomPropTypes/services';
import { person as personPropType } from 'lib/CustomPropTypes';
import { PersonContext } from 'lib/ContextTypes/person';

import AdsBundle from 'components/AdsBundle';
import { AnalyticsLaunchScripts } from 'components/AnalyticsLaunchScripts';
import { PersonLead } from 'components/PersonLead';
import { PersonFeed } from 'components/PersonFeed';
import { HeaderAndFooter } from 'components/services/HeaderAndFooter';
import IconfontStyleTag from 'components/IconfontStyleTag';
import { GlobalMetadata, PersonMetadata } from 'components/PageMetadata';

import 'assets/stylesheets/main.scss';
import 'assets/stylesheets/toolkit.scss';

import ErrorPage from '../_error';

import globalContainerStyles from '../globalContainerStyles.module.scss';


class PersonPage extends React.Component {
  static async getInitialProps(ctx) {
    const {
      asPath,
      res: {
        locals: {
          data: {
            person,
          },
          domain,
          hostname,
          services,
          vertical,
        },
      },
      store,
    } = ctx;
    let {
      res: {
        statusCode,
      },
    } = ctx;

    // Person does not have defined url, 'send' 404
    const hasUrl = get(person, ['url', 'canonical'], false);
    if (hasUrl === false) {
      statusCode = 404;
    }

    const pageView = 'person';

    await Promise.all([
      store.dispatch(setVertical(vertical)),
      store.dispatch(setPageView(pageView)),
      store.dispatch(globalLoadComplete({
        domain,
        host: hostname,
        navigating: false,
        path: asPath,
      })),
    ]);

    // Populate props with HFS component data
    const layout = {};
    if (services && services.layout && services.layout.getComponent) {
      layout.header = await services.layout.getComponent(vertical, 'header');
      layout.footer = await services.layout.getComponent(vertical, 'footer');
    }

    return {
      layout,
      person,
      statusCode,
    };
  }

  static propTypes = {
    layout: servicesLayoutPropType.isRequired,
    person: personPropType,
    statusCode: PropTypes.number.isRequired,
    themesCssPath: PropTypes.string,
    vertical: PropTypes.string.isRequired,
  };

  static defaultProps = {
    person: null,
    themesCssPath: null,
  };

  render() {
    const {
      layout,
      person,
      statusCode,
      themesCssPath,
      vertical,
    } = this.props;

    if (parseInt(statusCode, 10) >= 400) {
      return (
        <ErrorPage
          statusCode={statusCode === 404 ? 404 : 500}
          vertical={vertical}
          layout={layout}
        />
      );
    }

    return (
      <PersonContext.Provider value={person}>
        <GlobalMetadata />
        <PersonMetadata />

        <Head>
          {themesCssPath && (
            <link href={themesCssPath} rel="stylesheet" key={themesCssPath} />
          )}
          <IconfontStyleTag />
        </Head>

        <div
          className={classNames(
            globalContainerStyles.container,
            'bg-knockout-primary',
          )}
          id="content"
        >
          <HeaderAndFooter layout={layout}>
            <PersonLead />
            <PersonFeed />
          </HeaderAndFooter>
        </div>

        <AnalyticsLaunchScripts />
        <AdsBundle />
      </PersonContext.Provider>
    );
  }
}

export default PersonPage;
